import { GrowthBook } from '@growthbook/growthbook-react';
import { growthbookApiKey, devMode } from '../Config';

export const growthbook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: growthbookApiKey,
    enableDevMode: devMode,
    subscribeToChanges: true
});